import { Component } from '@angular/core';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
})
export class DownloadComponent {


  os;

  constructor() {

    this.os = this.getMobileOperatingSystem();

    if (this.os == 'iOS') {

      window.location.href = "https://apps.apple.com/us/app/cabbagepay/id1617564915";


    } if (this.os == 'Android') {

      window.location.href = "https://play.google.com/store/apps/details?id=com.cabbagepay.cabbage";


    } if (this.os == 'unknown') {


    }


  }


  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent;

    if (userAgent.toUpperCase().indexOf('ANDROID') > 0) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710

    if (userAgent.toUpperCase().indexOf('IPAD') > 0 || userAgent.toUpperCase().indexOf('IPHONE') > 0 || userAgent.toUpperCase().indexOf('IPOD') > 0) {
      return "iOS";
    }

    return "unknown";

  }


}
